<template>
  <div class="">
    <!-- 自定义消息-挂号 -->
    <im-custom-register v-if="Number(payload.type) === 10" :message="message" />
    <!-- 自定义消息-病例 -->
    <im-custom-case v-else-if="Number(payload.type) === 20" :message="message" />
    <!-- 自定义消息-医生开检查检验 -->
    <im-custom-inspect v-else-if="Number(payload.type) === 30" :message="message" />
    <!-- 自定义消息-医生开手术单 -->
    <im-custom-surgery v-else-if="Number(payload.type) === 35" :message="message" />
    <!-- 自定义消息-处方 -->
    <im-custom-prescription v-else-if="Number(payload.type) === 40" :message="message" />
    <!-- 自定义消息-系统提示 -->
    <!-- <im-custom-text
      v-else-if="Number(payload.type) === 99"
      :message="message"
    /> -->
    <!-- 自定义消息-邀请视频, 医生端不展示进入视频按钮 -->
    <im-custom-invite
      v-else-if="Number(payload.type) === 50"
      :message="inviteMessage"
      :show-btn="!isMe"
    />
    <!-- 自定义消息-转诊 -->
    <im-custom-invite-referral v-else-if="Number(payload.type) === 60" :message="message" />
    <!-- 自定义消息-未知 -->
    <div v-else class="im-unknow" :class="{ right: isMe }">
      <span class="text-box">暂未支持的消息类型</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imCardMessage',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {
      // inviteMessage: {}
    }
  },
  computed: {
    inviteMessage() {
      return {
        ...this.message,
        payload: {
          ...this.message.payload,
          data: JSON.stringify(this.payload)
        }
      }
    },
    isMe() {
      return this.message.flow === 'out'
    },
    payload() {
      let {
        payload: { data }
      } = this.message
      try {
        data = JSON.parse(data) || {}
        if (data.data && typeof data.data === 'string') {
          data = JSON.parse(data.data)
        }
        if (data.userData && typeof data.userData === 'string') {
          data = JSON.parse(data.userData)
        }
        // console.log('sssss', data)
        return data
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.im-unknow {
  display: inline-block;
  vertical-align: top;
  padding: 0.512rem 0.597333rem;
  font-size: 0.64rem;
  line-height: 0.853333rem;
  font-weight: 400;
  white-space: pre-wrap;
  word-break: break-all;
  background: #d4ebff;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;
  border-radius: 0 0.597333rem 0.597333rem 0.597333rem;

  &.right {
    border-radius: 0.597333rem 0 0.597333rem 0.597333rem;
    .text-box {
      text-align: left;
    }
  }
}
</style>
